export const colorArr = [
  '#3264FF',
  '#FF963C',
  '#6FC61F',
  '#E23636',
  '#914EE3',
]